import dayjs from 'dayjs'

export const formatTimestamp = (
  ts: number,
  format: string = 'YYYY-MM-DD HH:mm:ss'
): string => {
  const tspad =
    `${ts}`.length === 10 ? ts * 1000 : `${ts}`.length === 13 ? ts : null

  return tspad === null ? '--': dayjs(tspad).format(format)
}
